export default "__VITE_ASSET__c4ae9605__"